import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

import type { Option } from '@/types/common'

/**
 * Merges Tailwind class names, resolving any conflicts.
 *
 * @param inputs - An array of class names to merge.
 * @returns A string of merged and optimized class names.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Convert array of data to Combobox options
 * Supports:
 * - Static key access (e.g. 'name')
 * - Function mapper (e.g. (item) => `${item.first} ${item.last}`)
 * - Safe string conversion
 */
export function toOptions<T, V>(
  data: T[],
  getLabel: (item: T) => string,
  getValue: (item: T) => V
): (Option<V> & { data: T })[] {
  return data.map(item => ({
    label: getLabel(item),
    value: getValue(item),
    data: item,
  }))
}
